module.exports = __webpack_public_path__ + "images/tg11x5.62a8.png";